module.exports = __webpack_public_path__ + "img/loghi_0002_italianonprofit.50115482.png";